// import moment from "moment";
import resolve from "ng";
import angular from "angular";
import config from "servicestack/session.config";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import eventListener from "servicestack/event-listener";
import poll from "webutils/services/poll";
import $pageConfig from "webutils/services/page-config";
import recaptcha from "emun.auth/recaptcha/recaptcha.service";
import docCookies from "webutils/services/doc-cookies";

const SESSION_PROPS = [
  "fullName",
  "displayName",
  "company",
  "userAuthId",
  "salesRepId",
  "retailerId",
  "phone",
  "email",
];

export default class Session {
  constructor() {
    const session = this;
    session.$appConfig = $appConfig;
    session.bus = new ServiceBus();
    session.$interval = resolve("$interval");
    session.storage = resolve("$localStorage");
    session.sessionStorage = resolve("$sessionStorage");
    session.loaded = false;
    session.listeners = [];
    session.envTags = [];
    session.roles = [];
    session.permissions = [];
    session.initAutoLogout();
    session.initAuthenticationVerification();
    session.retailerType = "";
    //console.warn("Session.ServiceBus", session);
  }

  toggleHidePrice() {
    const session = this;
    session.sessionStorage.hidePrice = !session.sessionStorage.hidePrice;
  }

  initAuthenticationVerification() {
    const session = this;
    if (config.authenticationVerificationInterval > 5 * 1000) {
      /*console.info(
        "config.authenticationVerificationInterval",
        config.authenticationVerificationInterval
      );*/
      session.$interval(
        () => session.verifyAuthentication(),
        config.authenticationVerificationInterval
      );
    } else if (config.authenticationVerificationInterval > 0) {
      /*console.warn(
        "authenticationVerificationInterval must be greater than 5s",
        config
      );*/
    }
  }

  verifyAuthentication() {
    const session = this;
    if (session.isAuthenticated) {
      //console.warn("verifyingAuthentication", session);
      session.bus
        .send("auth/VerifyAuthentication.json")
        .then(({ data: isAuthenticated }) => {
          /*console.debug(
            "verifyAuthentication.isAuthenticated",
            isAuthenticated
          );*/
          if (!isAuthenticated) {
            //console.debug("verifyAuthentication.mismatch", isAuthenticated);
            session.$broadcast("$authenticationVerificationFailed", {
              isAuthenticated,
            });
            session.logout({ authenticationVerificationFailed: true });
          }
        });
    }
  }

  initAutoLogout() {
    const session = this;
    session.idleTime = new Date().getTime();
    const $$document = angular.element(document.body);
    if (config.autoLogoutTimeout > 60 * 1000) {
      // console.info("config.autoLogoutTimeout", config.autoLogoutTimeout);
      session.$interval(
        () => session.tryAutoLogout(),
        config.autoLogoutTimeout / 10
      );
      $$document.bind(
        "mousemove",
        () =>
          // console.debug("resetIdleSession.mousemove") ||
          (session.idleTime = new Date().getTime())
      );
      $$document.bind(
        "touchmove",
        () =>
          // console.debug("resetIdleSession.mousemove") ||
          (session.idleTime = new Date().getTime())
      );
    } else if (config.autoLogoutTimeout > 0) {
      console.warn("autoLogoutTimeout must be greater than 60s", config);
    }
  }

  msg(loading = false, ...context) {
    const session = this;
    if (!loading) {
      session.loading = false;
      session.loaded = new Date();
    } else {
      session.loadingAt = new Date();
      session.loading = `${session.loadingAt.toLocaleString()} - ${
        loading || "Loading..."
      }`;
      session.loaded = false;
      // resolve("notify").info(session.loading, {
      //   title: "Session...",
      //   ttl: 2000
      // });
    }
    //console.debug("session.msg", loading, { session, context });
  }

  tryAutoLogout() {
    const session = this;
    //console.info("session.idleTime", session.idleTime, new Date().getTime(), session.idleTime + config.autoLogoutTimeout);
    if (
      session.isAuthenticated &&
      session.idleTime + config.autoLogoutTimeout < new Date().getTime()
    ) {
      session.logout({ inactivityTimeout: true });
    }
  }

  logout({
    inactivityTimeout = false,
    authenticationVerificationFailed = false,
    message = "Logging out...",
  } = {}) {
    const session = this;
    session.msg(message);
    return session.bus.send("auth/logout.json").then((res) => {
      session.storage.sessionId = null;
      session.storage.orders = [];
      session.get();
      docCookies.removeItem("userEmail");
      docCookies.removeItem("fullName");
      session.$broadcast("$onLogout", res);
      if (inactivityTimeout) {
        session.$broadcast("$onInactivityLogout", res);
      }
      if (authenticationVerificationFailed) {
        session.$broadcast("$authenticationVerificationFailed", res);
      }
      return res;
    });
  }

  login(_request, forceLocal = false) {
    const request = {
      authProvider: "emun",
      rememberMe: true,
      ..._request,
    };
    const session = this;
    session.msg(`Authenticating...`, { request, forceLocal, _request });
    if (!$appConfig.isOffline || forceLocal || $appConfig.clientId) {
      console.warn("Authenticating!", { session, request, forceLocal });
      return recaptcha.verify("login").then(() => {
        const result = session.bus
          .send(`auth/${request.authProvider}.json`, request)
          .then((res) => session.onLoggedIn(request, res));
        result.catch(() => session.msg(false));
        return result;
      });
    } else {
      console.warn("No DB Version!", { session, request, forceLocal });
      return session.requestDataFile(request);
    }
  }

  onLoggedIn(request, res) {
    const session = this;
    const storage = resolve("$localStorage");
    console.warn("Session.onLoggedIn", {
      session,
      request,
      res,
      $appConfig,
      storage,
    });
    session.storage.sessionId = res.data.sessionId;
    if (config.clearSessionOrdersOnLogin) session.storage.orders = [];
    if ($appConfig.plugin || $appConfig.isOffline) {
      console.debug("Session.onLoggedIn.$appConfig", $appConfig);
      console.debug("Session.onLoggedIn.storage", storage);
      console.debug("Session.onLoggedIn.response", res.data);
      console.debug("Session.onLoggedIn.statusCode", res.status);
      console.debug("Session.onLoggedIn.session", session);
      Object.assign($appConfig, res.data);
    }
    Object.assign(storage, res.data);
    Object.assign(session, res.data);
    session.loginRequest = request;
    session.id = res.data.sessionId;
    //return window.location.reload(); // fix this later
    session.$broadcast("$onAuthenticated", { request, response: res });
    console.debug("Session.onLoggedIn.session", session);
    return session.get().then(() => $appConfig.init(session));
  }

  requestDataFile(_request = {}) {
    const session = this;
    const request = { ...session.loginRequest, ..._request };
    session.msg(`Requesting data from remote server...`, request);
    return session.bus
      .send("RequestDataFile.json", request)
      .then((res) => {
        request.requestId = res.data.requestId;
        return poll(() => {
          session.msg(`Waiting on data from remote server...`, request);
          console.debug("processDataFile", { session, request });
          return session.bus
            .send("ProcessDataFile.json", request)
            .then((dataFileResponse) => {
              console.debug("dataFileResponse", dataFileResponse.data);
              session.requestStatus = dataFileResponse.data;
              if (dataFileResponse.data.error) {
                session.msg(`unexpected error!!!!`, dataFileResponse);
                throw dataFileResponse.data.error;
              } else if (!dataFileResponse.data.isFileReady) {
                session.msg(
                  `File is ${dataFileResponse.data.status}...`,
                  dataFileResponse
                );
              } else {
                session.msg(
                  `New database is being prepared...`,
                  dataFileResponse
                );
              }
              return dataFileResponse.data.isFileReady;
            });
        })
          .then(() => {
            session.databaseVersion = session.clientId = new Date();
            console.debug("onDataFileProcessed", { session, request });
            if (request.password) {
              console.warn("session.login(request, true);", {
                session,
                request,
              });
              return session.login(request, true);
            }
            return session.onLoggedIn(request, session);
          })
          .catch((e) => {
            console.debug("onDataFileFailed", { e, session, request });
            session.errorMessage = e.message;
            return session.msg(false);
          });
      })
      .catch((e) => {
        console.debug("RequestDataFile.FAILED", e);
        session.errorMessage = "Could not authenticate with remote server";
        return session.msg(false);
      });
  }

  $emit() {
    const $rootScope = resolve("$rootScope");
    $rootScope.$emit.apply($rootScope, arguments);
  }

  $on() {
    const $rootScope = resolve("$rootScope");
    return this.listeners.push($rootScope.$on.apply($rootScope, arguments));
  }

  $broadcast() {
    const $rootScope = resolve("$rootScope");
    return this.$broadcast.apply($rootScope, arguments);
  }

  ready(cb) {
    return this.$$lastCall.then(cb);
  }

  get() {
    const session = this;
    SESSION_PROPS.forEach((p) => delete session[p]);
    session.msg(`Retreiving session...`);

    //mailchimp cookie
    let params = new URLSearchParams(window.location.search);

    let campaignId = params.get("mc_cid");
    if (campaignId) {
      docCookies.setItem("campaignId", campaignId);
    }

    return (session.$$lastCall = session.bus
      .send("auth/session.json")
      .then((res) => {
        session.loaded = new Date();
        session.msg(false);
        Object.assign(session, res.data);
        session.$broadcast("$onSessionLoaded", session);

        if (
          !docCookies.getItem("userEmail") ||
          docCookies.getItem("userEmail") == undefined ||
          docCookies.getItem("userEmail") == null ||
          docCookies.getItem("userEmail") != session.primaryEmail
        ) {
          console.info(
            "Email Cookie",
            docCookies.getItem("userEmail"),
            session.primaryEmail
          );
          docCookies.setItem("userEmail", session.primaryEmail);
          docCookies.setItem("fullName", session.fullName);
        }

        session.checkMessages();
        session.getUserMeta();
        if (session.retailerId) session.getRetailerInfo();

        if (session.enableServerEvents) {
          eventListener.getEventSource(session);
        }
        window._loq = window._loq || [];
        window._loq.push([
          "custom",
          SESSION_PROPS.reduce((s, p) => ({ ...s, [p]: session[p] }), {
            id: res.data.id,
          }),
        ]);
        return session;
      }));
  }

  checkMessages() {
    const session = this;
    session.bus.read("QueryBlogs.json", {onlyNew: 1}).then(function(args) {
      session.storage.NewMessages = args.data.total;
    });
  }
  getUserMeta() {
    const session = this;
    session.bus.read("QueryUsers.json", {Id: this.userAuthId}).then(function(args) {
      if (args.data.results.length) {
        Object.assign(session.meta, args.data.results[0].meta);
        Object.assign(session.permissions, args.data.results[0].permissions);
      }
    })
  }
  getRetailerInfo() {
    const session = this;
    session.bus.read("QueryRetailers.json", {Id: this.retailerId}).then(function(args) {
      if (args.data.results.length) session.retailerType = args.data.results[0].customerType;
    })
  }

  isRepOrAbove() {
    return this.hasRole(
      "Administrator",
      "Corporate",
      "Rep",
      "Sales Rep",
      "Manager",
      "Sales Manager",
      "SubRep", "Sub Rep"
    );
  }

  isManagerOrAbove() {
    return this.hasRole(
      "Administrator",
      "Corporate",
      "Manager",
      "Sales Manager"
    );
  }

  isRep() {
    return this.hasRole("Rep", "Sales Rep");
  }

  isRepOrManager() {
    return this.hasRole("Rep", "Sales Rep", "Manager", "Sales Manager");
  }

  isSubRep() {
    return this.hasRole("SubRep", "Sub Rep");
  }

  isManager() {
    return this.hasRole("Sales Manager", "Manager");
  }

  isAdministrator() {
    return this.hasRole("Administrator");
  }

  isSalesManagementMode() {
    return this.salesManagementMode;
  }

  isImpersonating() {
    return this.meta && this.meta.OriginalSessionId;
  }

  hasMultipleBillTos() {
    return this.meta && this.meta.RetailerBillTos;
  }

  hasAcceptedTerms() {
    return this.meta && this.meta.AcceptedTerms;
  }

  isAgency() {
    return this.meta && this.meta["AgencyMode"] ? true : false;
  }

  isCronofyEnterprise() {
    return this.meta && this.meta["CronofyEnterprise"] ? true : false;
  }

  isOffline() {
    return this.hasEnvTag("Offline", "iOS", "CefSharp") ||
      (this.meta && this.meta["OfflineMode"] === "true")
      ? true
      : false;
  }

  isMobile() {
    return $pageConfig.isMobile();
  }

  isShowroom() {
    return this.hasEnvTag("Showroom") || (this.meta && this.meta["LoginMode"] === "Showroom");
  }

  isCrm() {
    return this.hasEnvTag("Crm");
  }

  isCms() {
    return this.hasEnvTag("Cms");
  }

  isCorporate() {
    return this.hasRole("Corporate");
  }

  isCorpOrAbove() {
    return this.hasRole("Administrator", "Corporate");
  }
  canBulkDownload () {
    return !((this.isRepOrManager() || this.isVendor()) && this.isShowroom());
  }
  isRetailerOrAbove() {
    return this.hasRole(
      "Administrator",
      "Corporate",
      "Rep",
      "Sales Rep",
      "Manager",
      "Sales Manager",
      "Retailer"
    );
  }

  isTemporary() {
    if (this.fullName === "Temporary User") return true;
    else return false;
  }

  isConsumer() {
    return this.hasRole("Consumer");
  }

  isRetailer() {
    return this.hasRole("Retailer");
  }

  isVendor() {
    return this.hasRole("Vendor");
  }

  isRepGroup() {
    return this.hasRole("RepGroup");
  }

  isInsideSales() {
    return this.salesRepId === "Inside Sales";
  }

  isExecutiveManager() {
    return (
      this.salesRepId === "846" ||
      this.salesRepId === "SteveB" ||
      this.salesRepId === "CPovoli"
    );
  }

  authorize(fn) {
    const session = this;
    let $q = resolve("$q");
    return $q.resolve(session).then(() => {
      let $state = resolve("$state");
      var redirect = fn(session, $state);
      if (redirect) {
        if (typeof redirect === "string") $state.go(redirect);
        else if (redirect.state) $state.go(redirect.state, redirect.options);
        else for (var state in redirect) $state.go(state, redirect[state]);
      }
    });
  }

  hasRole() {
    if (this.roles && this.roles.length) {
      for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < this.roles.length; j++) {
          if (
            arguments[i] === this.roles[j] ||
            (Array.isArray(arguments[i]) &&
              arguments[i].indexOf(this.roles[j]) >= 0)
          )
            return true;
        }
      }
    }
    return false;
  }

  hasPermission() {
    //console.info("BL*** permissions = " + JSON.stringify(this.permissions));
    const list = [...arguments]; // AllPermissions handled server side
    if (this.permissions && this.permissions.length) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < this.permissions.length; j++) {
          if (list[i] === this.permissions[j]) return true;
        }
      }
    }
    return this.isAdministrator() || (config.allowAllPermission && this.permissions.indexOf("AllPermissions") >= 0);
  }

  hasEnvTag() {
    if (this.envTags && this.envTags.length) {
      for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < this.envTags.length; j++) {
          if (
            arguments[i] === this.envTags[j] ||
            (Array.isArray(arguments[i]) &&
              arguments[i].indexOf(this.envTags[j]) >= 0)
          )
            return true;
        }
      }
    }
    return false;
  }

  $onDestroy() {
    this.dispose();
  }

  dispose() {
    this.bus.dispose();
    this.listeners.forEach((un) => un());
  }
}

/*


[Display(Description = "Administrative Priviledges (NEW)")]
AllPermissions,
[Display(Description = "View Activities (NEW)")]
ViewActivities,
[Display(Description = "View Calendar (NEW)")]
ViewCalendar,
[Display(Description = "View Documents (NEW)")]
ViewDocuments,


[Display(Description = "View All Price Lists")]
AllPriceLists,
[Display(Description = "View Customer Quick Stats")]
CustomerQuickStats,
[Display(Description = "Delete Orders From Grid")]
DeleteGridOrders,
[Display(Description = "Can Download and Email Images")]
DownloadEmailImages,
[Display(Description = "Can Edit Any Store Information")]
EditCustomerInfo,
[Display(Description = "Maintain Users")]
MaintainUsers,
[Display(Description = "Can Manage Media")]
ManageMedia,
[Display(Description = "View Promo Sheet")]
PromoSheet,
[Display(Description = "Can Run Dealer Reports")]
RunDealerReports,
[Display(Description = "Can Run Product Reports")]
RunProductReports,
[Display(Description = "View Product Price")]
SeePrice,
[Display(Description = "View Price on Product Grid")]
SeePriceProductGrid,
[Display(Description = "View Order/Invoice History")]
ViewOrderInvoiceHistory,
[Display(Description = "Can Enter Container Orders")]
WriteContainerOrders,
[Display(Description = "Can Enter Orders")]
WriteOrders,
[Display(Description = "Can Enter Partial Container Orders")]
WritePartialContainerOrders,
[Display(Description = "Modify Promo Sheets")]
WritePromoSheet,
[Display(Description = "Can Enter Special Container Orders")]
WriteSpecialContainerOrders
*/
